import { render, staticRenderFns } from "./AddonRow.vue?vue&type=template&id=5e6d495b&scoped=true&"
import script from "./AddonRow.vue?vue&type=script&lang=js&"
export * from "./AddonRow.vue?vue&type=script&lang=js&"
import style0 from "./AddonRow.vue?vue&type=style&index=0&id=5e6d495b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6d495b",
  null
  
)

export default component.exports